<template>
  <div class="tag-badge">
    <tag-actions-popover :tag="tag">
      <span class="capitalized">{{ tag.title }}</span>
    </tag-actions-popover>
  </div>
</template>

<script>
import TagActionsPopover from './TagActionsPopover'

export default {
  name: 'TagBadge',
  components: { TagActionsPopover },
  props: {
    tag: { type: Object, required: true }
  },
  computed: {
  }
}
</script>

<style lang="scss">
  @import "../../../assets/styles/vars";
  .tag-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    min-height: $tag-inline-height;
    min-width: $basic-size * 2;
    padding: $tag-padding $basic-padding;
    margin: 0 $tag-padding $tag-padding 0;

    border-radius: $tag-corner-radius;
    background: $dynamic-paper-color;
  }
</style>
